/**
 * `19$` — amount then symbol, matching how the plans themselves are named
 * ("LifeTime - 7$"). Unknown currencies fall back to the ISO code.
 */
const CURRENCY_SUFFIX: Record<string, string> = {
  usd: '$',
  eur: '€',
  gbp: '£',
};

export function formatPrice(
  amount: number | null | undefined,
  currency: string | null | undefined,
): string | null {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) {
    return null;
  }

  // Whole amounts read better without trailing zeros: 19$ rather than 19.00$.
  const value = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
  const code = currency?.trim().toLowerCase();
  const suffix = code ? (CURRENCY_SUFFIX[code] ?? ` ${code.toUpperCase()}`) : '';

  return `${value}${suffix}`;
}
